<button class="icon-button" [title]="title"><ng-content></ng-content></button>
